import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { Button } from "../../../common/Button/Button";
import moment from "moment";

export default function ConfirmationModal(props) {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent>
        <div className="m-3">
          <span>{props.message}</span>
          <div className="mt-4 flex">
            <div>
              <Button onClick={props.changeState}>
                {props.buttonText === undefined ? "OK" : props.buttonText}
              </Button>
              <span className="ml-2 cursor-pointer" onClick={props.toggleModal}>
                Cancel
              </span>
            </div>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
}
